export enum PortalTypeEnum {
  Admin = 1,
  Facility = 2,
  Sales = 3,
  Patient = 4,
}

export enum UserType {
  Master = 0,
  LabUser = 1,
}

export enum GlobalAccountTypeEnum {
  Username = 0,
  Email = 1,
}

export enum LabType {
  Primary = 0,
  Reference = 1,
  POL = 2,
}

export enum PageFieldControlType {
  Textbox = "textbox",
}
